export type UploadRequirementsSheetRequest = {
  pjtId: string;
  file: File[];
  updateDateTime: string;
};
